var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEndingLock = function SvgIconEndingLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.356 9.022a7 7 0 0 0-5.725-7.81l-.3-.046a7 7 0 0 0-7.809 5.725l2.757.486.05-.242a4.2 4.2 0 0 1 4.816-3.165l.242.05a4.2 4.2 0 0 1 3.165 4.816l-.73 4.136-13.196-2.327a2 2 0 0 0-2.317 1.622L3.086 24.873A2 2 0 0 0 4.71 27.19l18.12 3.195a2 2 0 0 0 2.317-1.623l2.223-12.605a2 2 0 0 0-1.622-2.317l-2.167-.382.73-4.136.046-.3Zm-12.561 9.746a1.25 1.25 0 0 1 1.662.206l.079.101.888 1.27 3.564-2.495a1.25 1.25 0 0 1 1.663.206l.078.1a1.25 1.25 0 0 1-.206 1.663l-.1.079-4.588 3.212a1.25 1.25 0 0 1-1.662-.206l-.079-.101-1.606-2.294a1.25 1.25 0 0 1 .307-1.74Z",
    fill: "#fff"
  })));
};
export default SvgIconEndingLock;